import { render, staticRenderFns } from "./PriceManagerButton.vue?vue&type=template&id=bd792c52&"
import script from "./PriceManagerButton.vue?vue&type=script&lang=js&"
export * from "./PriceManagerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports